import type { PlaybackRate, TTSLanguage } from '../../types/tts';
import {
  TextToSpeechDisplayNameByVoice,
  TextToSpeechGender,
  TextToSpeechGenderByVoice,
  TextToSpeechVoice,
} from '../../types/tts';

const TextToSpeechDisplayNameMale = 'Finley';
const TextToSpeechDisplayNameFemale = 'Rey';
export function getTextToSpeechDisplayName(voice: TextToSpeechVoice): string {
  const voiceOverride = TextToSpeechDisplayNameByVoice[voice];
  if (voiceOverride !== undefined) {
    return voiceOverride;
  }
  const foundVoice = Object.keys(TextToSpeechVoice).find(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- Object.keys returns string[]; voiceValue is always a valid key of TextToSpeechVoice enum since we iterate its own keys
    (voiceValue) => TextToSpeechVoice[voiceValue as keyof typeof TextToSpeechVoice] === voice,
  );
  if (foundVoice) {
    return foundVoice;
  }
  const isMale = TextToSpeechGenderByVoice[voice] === 'male';
  return isMale ? TextToSpeechDisplayNameMale : TextToSpeechDisplayNameFemale;
}

export const textToSpeechDefaultLanguage: TTSLanguage = 'en';
export const textToSpeechDefaultGender: TextToSpeechGender = 'female';
export const textToSpeechDefaultPlaybackRate: PlaybackRate = 1;
export const textToSpeechDefaultVolume = 1;

// Average speech rate used to convert character offsets to seconds of TTS audio.
// Mirrors CHARS_PER_SECOND in reader/integrations/unreal_speech_v1.py and the equivalent
// estimation math in reader/integrations/azure.py — keep in sync with the backend.
export const TTS_CHARS_PER_SECOND = 16.7;

// Below this many seconds into a chunk, start TTS from the chunk beginning instead of
// mid-chunk. Mirrors MAX_FRAGMENT_SECONDS in reader/integrations/unreal_speech_v1.py:
// under one backend fragment the mid-chunk silence fast-path buys nothing — fragment 0
// is the audio we need anyway. Keep in sync with the backend.
export const TTS_SNAP_TO_START_SECONDS = 30;
